/**
 * The API decides (`PartyResource.editable` = PartyPolicy::update for the current user):
 * imported records (Cobra/WinCasa/SE/Altportal) and missing permissions both yield `false`.
 * @param {{ editable?: boolean }} party
 */
export function isPartyEditable(party) {
  return party?.editable === true;
}

/** Imported = maintained in a source system (read-only for that reason, not for lack of permission). @param {{ source?: string|null }} party */
export function isImportedParty(party) {
  return Boolean(party?.source) && party.source !== 'manual';
}

const EMPTY_CONTACT = { kind: 'email', value: '', label: '', is_primary: false };
export const emptyContact = () => ({ ...EMPTY_CONTACT });

/** API party → form values ('' instead of null, only manual contacts). @param {any} party */
export function partyToForm(party) {
  const s = (v) => v ?? '';
  return {
    type: party?.type ?? 'person',
    salutation: s(party?.salutation),
    title: s(party?.title),
    first_name: s(party?.first_name),
    last_name: s(party?.last_name),
    organization_name: s(party?.organization_name),
    letter_salutation: s(party?.letter_salutation),
    birthday: s(party?.birthday),
    notes: s(party?.notes),
    contacts: (party?.contacts ?? [])
      .filter((c) => !c.source || c.source === 'manual')
      .map((c) => ({ kind: c.kind, value: c.value ?? '', label: c.label ?? '', is_primary: Boolean(c.is_primary) })),
  };
}

/**
 * Form values → API payload. Empty strings become null; person-only fields are not sent
 * for organizations. `type` is only sent on create (prohibited on update).
 * @param {ReturnType<typeof partyToForm>} values
 * @param {{ create: boolean }} options
 */
export function formToPartyPayload(values, { create }) {
  const n = (v) => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);
  const isPerson = values.type === 'person';
  /** @type {Record<string, any>} */
  const payload = {
    organization_name: n(values.organization_name),
    letter_salutation: n(values.letter_salutation),
    notes: n(values.notes),
    contacts: values.contacts.map((c) => ({ kind: c.kind, value: c.value.trim(), label: n(c.label), is_primary: Boolean(c.is_primary) })),
  };
  if (isPerson) {
    Object.assign(payload, {
      salutation: n(values.salutation),
      title: n(values.title),
      first_name: n(values.first_name),
      last_name: n(values.last_name),
      birthday: n(values.birthday),
    });
  }
  if (create) payload.type = values.type;
  return payload;
}
